<template>
  <b-card>
    <full-calendar ref="calendar" class="mt-4" :config="calendarConfig" :events="calendarEvents" @view-render="onViewRender" />
  </b-card>
</template>

<script>
import { FullCalendar } from 'vue-full-calendar';
import 'fullcalendar/dist/fullcalendar.css';
import 'fullcalendar/dist/locale/pl';

import { UserResource } from '../../resources/user.resource';
import CalendarService from '../../services/calendar.service';
import AuthenticationService from '../../services/authentication.service';

export default {
  components: { FullCalendar },
  data() {
    return {
      calendarConfig: {
        defaultView: 'month',
        editable: false,
        locale: 'pl',
        selectable: false,
        displayEventEnd: true
      },
      calendarEvents: [],
      ids: undefined
    };
  },
  mounted() {
    this.ids = this.$route.query.ids.split(',');
    this.getWorkdays();
  },
  computed: {
    year() {
      return this.$route.query.year;
    },
    month() {
      return this.$route.query.month;
    }
  },
  methods: {
    getWorkdays() {
      if (!this.ids || !AuthenticationService.is('manager', 'admin', 'hr')) {
        return;
      }
      const promises = this.ids.map(id => UserResource.workdays(parseInt(this.month, 10), parseInt(this.year, 10), parseInt(id, 10)));
      Promise.all(promises).then(workdays => this.parseWorkdays(workdays));
    },

    setQueryParams(year, month) {
      this.$router.replace({
        query: { ...this.$route.query, year, month }
      });
    },

    onViewRender(view) {
      this.setQueryParams(view.intervalStart.year(), view.intervalStart.month() + 1);
      this.getWorkdays();
    },

    parseWorkdays(arrays) {
      const workdays = arrays.flatMap(item => item.workdays);
      this.calendarEvents = workdays
        .map(workday => CalendarService.workdayToCalendarEvent(workday))
        .map(workday => {
          workday.title = `\n${workday.user.firstName} ${workday.user.lastName} ${workday.title}`;
          return workday;
        });
    }
  },
  created() {
    if (!this.$route.query.year || !this.$route.query.month) {
      const now = new Date();
      return this.setQueryParams(now.getFullYear(), now.getMonth() + 1);
    }
  }
};
</script>
